import { useMemo } from 'react';

import './PasswordRuleValidator.scss';
import Icon from '../Icon/Icon';

type PasswordRule = {
  validated: boolean;
  label: string;
  validator: (password: string) => boolean;
};

const hasMinLength = (password: string): boolean => password?.length >= 8;
const hasSymbol = (password: string): boolean => /[^A-Za-z0-9]/.test(password);
const hasNumber = (password: string): boolean => /\d/.test(password);
const hasUppercase = (password: string): boolean => /[A-Z]/.test(password);

const baseRules: Omit<PasswordRule, 'validated'>[] = [
  { label: 'Contém ao menos 8 caracteres', validator: hasMinLength },
  { label: 'Contém ao menos 1 símbolo', validator: hasSymbol },
  { label: 'Contém ao menos 1 número', validator: hasNumber },
  { label: 'Contém ao menos 1 letra maiúscula', validator: hasUppercase }
];

interface PasswordRuleValidatorProps {
  password: string;
}

export default function PasswordRuleValidator({
  password
}: PasswordRuleValidatorProps) {
  const rules = useMemo<PasswordRule[]>(
    () =>
      baseRules.map((rule) => ({
        ...rule,
        validated: rule.validator(password)
      })),
    [password]
  );

  return (
    <div className="password-rule-validator mt-4">
      {rules.map((rule, index) => (
        <p key={index} className={`${rule.validated ? 'validated' : ''}`}>
          <Icon
            width={24}
            height={24}
            name={rule.validated ? 'success' : 'close'}
          />{' '}
          {rule.label}
        </p>
      ))}
    </div>
  );
}
